import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { Validators, FormControl } from "@angular/forms";
const swal = require('sweetalert');
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { environment } from '../../../../../environments/environment';
import { ItemServiceService } from 'src/app/POS/POSServices/Setup/item-service.service';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {
  Flag=0;
  ActualAmount:any;
  EditdiscountType:any;
  EditdiscountValue:any;
  paramcategoryid:any;
  noImageavalabel:boolean=false;
  Imageavalabel:boolean=false;
  noImageavalabel1:boolean=false;  
  Imageavalabel1:boolean=false;
 imageurl:any;
  rowid:any;
  rdatetime:any;
  rid:any;
  duplicateproductcode:boolean=false;
  isReadytoUpdateitem : boolean = false;
  imagecheck:any;
  contenttype:any;
  imagefile:any;

  fileSize: any;
maxFileSize =4000;
isFileHavingProperSize : boolean = false;

maxWidth = 200;
maxHeight = 200;
content:any;
  EditCategoryName:any;
  merchantdata: UserPOSData ;
  categorynameid;
  Type = [
    { text: "Fixed", value: "Fixed" },
    { text: "Variable", value: "Variable" },
    { text: "Per Unit", value: "Per Unit" },


  ];
  Type1= [
    { text: "Fixed", value:"Fixed"},
    { text: "Percentage", value: "Percentage"}
  ];
  TaxFeeRate:any;
  taxfee:any;
  TaxFeeId:any;
  ContentType:any;
  img:any
 imageUrl: string = "/assets/img/default-image.png";
  fileToUpload: File = null;

myFiles:string [] = [];
DateTime;
isUploadFile:boolean = false;
isfileValid:boolean = true;
validFileExtensions;

  isNewitem: boolean = true;
  isUpdateitem: boolean = false;
  rows;
  ptype:any;
  PriceTypedata;
  itemimage:any;
  imageSource:any;
  Categoryid= new FormControl("", [Validators.required]);
  categorynames= new FormControl("", [Validators.required]);
  type= new FormControl("", [Validators.required]);

  Name = new FormControl("", [Validators.required, Validators.maxLength(50), Validators.minLength(1)]);
  // , Validators.pattern("^(?! )[a-zA-Zs0-9 ]+[0-9]*$")
  AlternativeName = new FormControl("", [Validators.maxLength(50), Validators.minLength(1)]);
  Description  = new FormControl("", [Validators.required, Validators.maxLength(500), Validators.minLength(1)]);
  ItemOptions = new FormControl("", [Validators.required,Validators.pattern("^(?! )[0-9]+?$")]);
  Price =new FormControl("", [Validators.required,Validators.min(1),Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);
  PriceType =new FormControl("", [Validators.required,Validators.pattern("^(?! )[0-9]+?$")]);
  Taxes =new FormControl("", [Validators.required]);

  // ,Validators.pattern("^(?! )[0-9]+?$")
  DiscountValue=new FormControl("",Validators.required);
  DiscountType = new FormControl("",Validators.required);
  ProductCode = new FormControl("", [Validators.required]);
  BarCode= new FormControl("", []);
  GTIN= new FormControl("", []);
  Sku = new FormControl("", []);
  HSNCode= new FormControl("", []);
  UpdateduserId = new FormControl("", [Validators.required]);
  UpdatedDateTime = new FormControl("", [Validators.required]);
id= new FormControl("", [Validators.required]);
ContactPerference  = new FormControl("", [Validators.required]);
isMyList=[];
categorylist=[];
taxfeelist=[];

editing = {};
  row = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  category = [];
  cid= [];

  rowsSel = [];
  selected = [];
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: ItemServiceService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetcategorytaxfeeDetails();
    this.GetitemcategoryList((data) => {
      
     });
  }
  GetitemcategoryList(cb) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
    this.service.GetItemCategoryListUrl(merchantdata.PosSubscriptionId).subscribe(data => {   
    if(data !=null)
    {
      this.temp = _clone(data);
      this.row = _clone(data);
      this.isMyList = data;
      this.categorylist = data;
      if(this.row !=null)
      {
        this.getGetitemDetails();
      }
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
    }
  });
  //   req.open('GET',environment.GetItemCategoryListUrl+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
  // //   req.open('GET', `https://uatapi.fastswiff.com/virtualPOS/api/PrepaidCards/Manage?MerchantKeyId=3`);
  
  //   req.onload = () => {
  //       cb(JSON.parse(req.response));
  //   };
  
  //   req.send();
  }

  taxtypeSelection()
  {
    this.isReadytoUpdateitem = true;
   var categoryid=this.categorynames.value;
   for(var i=0;i<this.isMyList.length;i++)
   {
      var taxtypeid= this.isMyList[i].Id;
      if(categoryid==taxtypeid)
      {
          for(var j=0;j<this.taxfeelist.length;j++)
          {
            if(this.isMyList[i].TaxType==this.taxfeelist[j].TaxFeeName)
            {
              
              this.TaxFeeRate=this.taxfeelist[j].TaxRate;
            }
          }
        
      }
   }
  }
  edittaxtypeSelection()
  {
   var categoryid=this.categorynames.value;
   if(categoryid !=null)
  {
    for(let i=0;i<this.isMyList.length;i++)
    {
    if(categoryid==this.isMyList[i].CategoryName)
    {
     categoryid=this.isMyList[i].Id
    }
  }
}
   for(var i=0;i<this.isMyList.length;i++)
   {
      var taxtypeid= this.isMyList[i].Id;
      if(categoryid==taxtypeid)
      {
          for(var j=0;j<this.taxfeelist.length;j++)
          {
            if(this.isMyList[i].TaxType==this.taxfeelist[j].TaxFeeName)
            {
              
              this.TaxFeeRate=this.taxfeelist[j].TaxRate;
            }
          }
        
      }
   }
  }

  



 
  getGetcategorytaxfeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });  

    this.service.GetCategoryTaxFeeList(form).subscribe(result => {  
      this.taxfeelist = result;
   
      console.log("result.Id---" + result);
     
    });
 
   
 
  }

 
  getGetitemDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      this.paramcategoryid= params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    if(this.paramcategoryid>0) 
   {
    this.service.GetItemDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id > 0) {
        this.content=result.Content;
        if(this.content ==null || this.content =='')
        {
          this.noImageavalabel=true;
          this.Imageavalabel=false;
        }
        else{
          this.noImageavalabel=false;
          this.Imageavalabel=true;

        }
     
     this.imagefile= result.ImageFile;
     this.contenttype=result.ContentType;
     if(result.ImageFile!=null&&result.ImageFile!="")
     {
     this.imageurl = result.ImageFile;
     if(this.imageurl ==null || this.imageurl ==" ")
     {
       this.noImageavalabel1=true;
       this.Imageavalabel1=false;
     }
     else{
       this.noImageavalabel=false;
       this.Imageavalabel1=true;

     }
   }
        if(this.content !=null)
        {
          this.imagecheck="Image Is Avaible";
          // alert(this.imagecheck);
        }
        if(result.PriceType == 0)
        {
          this.PriceTypedata="Fixed";
        }
        else if(result.PriceType == 1)
        {
          this.PriceTypedata = "Variable";
        }
        else if(result.PriceType == 2)
        {
        
          this.PriceTypedata="Per Unit";
        }
        this.DateTime=result.DateTime;
        this.isUpdateitem = true;
        this.isNewitem = false;
        this.rows = result;
        this.EditdiscountType=this.rows.DiscountType;
        this.EditdiscountValue=this.rows.DiscountValue;
        this.ActualAmount=result.ActualAmount;
        this.rid=result.Id;
        this.rdatetime=result.DateTime;
        if(this.rows.CategoryId !=null)
        {
          for(let i=0;i<this.isMyList.length;i++)
          {
                  if(this.isMyList[i].Id==this.rows.CategoryId)
                  {
                    let index = this.isMyList.findIndex(x => x.categoryName == this.isMyList[i].CategoryName);
                        this.EditCategoryName=this.isMyList[i].CategoryName;

                         this.rowid= this.isMyList[i].Id
                        //  this.categorylist.splice(index, 1);   
                  }
          }

        }
        // this.TaxFeeRate=this.rows.TaxFeeRate;
        this.TaxFeeRate=this.rows.TaxFeeId;
        for(var i=0;i<this.isMyList.length;i++)
        {
          
         this.category =this.rows.CategoryId;
         this.cid=  this.isMyList[i].Id
         if(this.category==this.cid)
         {
           this.rows.CategoryName=this.isMyList[i].CategoryName;
         }
        }
       
      }
       else {
        this.isUpdateitem = false;
        this.isNewitem = true;
      }
    });
  }
 
  }


  // oncategorySelection()
  // {
  //   var selectedValue=this.categorynames.value;
  //   for (var _i = 0; _i < this.isMyList.length; _i++) {
  //     if(this.Categoryid.value == this.isMyList[_i].categoryName)
  //     {
  //       this.categorynameid = this.isMyList[_i].id;
  //     }
  // }
  // }


  onChange()
  {
    let form = { merchantKeyId: "", CategoryName:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.CategoryName = this.Categoryid.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCategoryName(form).subscribe(result => {   
      if(result==null)
      {
        this.categorynameid=result.Id;
        
      }
      else{
       
    
      }
    });
 
  }

  newitem() {
   
    localStorage.removeItem('itemslist');
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      Name  :"",
      AlternativeName   :"",
      Description   :"",
      // ItemOptions   :"",
      Price   :"",
      PriceType   :"",
      DiscountType :"",
      DiscountValue :"",
      TaxFeeId   :"",
      ProductCode   :"",
      BarCode:"",
      GTIN:"",
      Sku   :"",
      UpdateduserId    :"",
      UpdatedDateTime    :"",
      // ImageSource:"",
      Source:"",
      ContentType:"",
      CategoryId:"",
      HSNCode:"",

      };
    //form.categoryId=this.type.value;
    form.HSNCode=this.HSNCode.value;
       form.CategoryId=this.categorynames.value;
    form.Name = this.Name.value;
    form.AlternativeName = this.AlternativeName.value;
    form.Description = this.Description.value;
    // form.ItemOptions = this.ItemOptions.value;
    form.Price = this.Price.value;
    form.PriceType = this.PriceType.value;
    form.DiscountType=this.DiscountType.value;
    form.DiscountValue=this.DiscountValue.value;
    if(form.PriceType=="Fixed")
    {
      form.PriceType ="0";
    }
    else if(form.PriceType=="Variable")
    {
      form.PriceType="1" ;
    }
    else if(form.PriceType=="Per Unit")
    {
      form.PriceType="2" ;
    }
    form.TaxFeeId=this.Taxes.value;
    for(var i=0;i<this.isMyList.length;i++)
    {
     if(form.TaxFeeId==this.isMyList[i].CategoryName)
     {
      form.TaxFeeId= this.isMyList[i].Id;
     }
    }
    form.ProductCode=this.ProductCode.value;
    form.BarCode=this.BarCode.value;
    form.GTIN=this.GTIN.value;
    form.Sku=this.Sku.value;
    form.UpdateduserId=this.UpdateduserId.value;
    form.UpdatedDateTime=this.UpdatedDateTime.value;
    // form.ImageSource=this.itemimage;
    form.Source=this.itemimage;
  form.ContentType=this.ContentType;
  
 // form.ContentType=this.myFiles[0];

     const frmData = new FormData();
    frmData.append("fileUpload", this.myFiles[0]);
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.AddItem(form).subscribe(result => {
      console.log(" result - ", result);
      if(result.ProductCode !=="Product is already registered")
      {
        this.duplicateproductcode=false;
        if (result != null) {
          this.service.InsertItem(result.Id,merchantdata.PosSubscriptionId,frmData).subscribe(result => {
  
          })
    
          var length = +localStorage.getItem('orderlength')
          if(length>0)
          {
            swal("Added", "Items Added Successfully", "success"); 
          this.router.navigate(["/pos/item/manage"]);
          }
          else
          {
            this.router.navigate(["/pos/setup"]);
          }
      }
      }
      else{
              this.duplicateproductcode=true;
      }
    
    });
  }
  // getFileDetails (file:FileList) {
  //   // this.itemimage=file.item(0).name;
  //   this.itemimage=file.item(0).name;
  //   this.ContentType=file.item(0).type
  //   var reader = new FileReader();
  //   this.img = file;
  //   reader.readAsDataURL(file[0]); 
  //   reader.onload = (_event) => { 
  //     this.img = reader.result; 
  //   }
  // }
  
  updateitem()
  {
    localStorage.removeItem('itemslist');
    let form = {
      PosSubscriptionId:"",
      CustomerId :"",
      Name  :"",
      AlternativeName   :"",
      Description   :"",
      // ItemOptions   :"",
      Price   :"",
      PriceType   :"",
      TaxFeeId   :"",
      ProductCode   :"",
      Sku   :"",
      UpdateduserId    :"",
      UpdatedDateTime    :"",
      id:"",
      imageSource:"",
      DateTime:"",
      CategoryId:"",
      BarCode:"",
      GTIN:"",
      content:"",
      ContentType:"",
      HSNCode:"",
      DiscountType :"",
      Flag:1,
      DiscountValue :"",
      ActualAmount:""
      };
      form.ActualAmount=this.ActualAmount;
      form.DiscountType=this.DiscountType.value;
      form.DiscountValue=this.DiscountValue.value;
      form.HSNCode=this.HSNCode.value;
      form.CategoryId=this.categorynames.value;
      if(form.CategoryId !=null)
      {
        for(let i=0;i<this.isMyList.length;i++)
        {
        if(form.CategoryId==this.isMyList[i].CategoryName)
        {
          form.CategoryId=this.isMyList[i].Id
        }
      }
    }
      form.BarCode=this.BarCode.value;
    form.Name = this.Name.value;
    form.AlternativeName = this.AlternativeName.value;
    form.Description = this.Description.value;
    // form.ItemOptions = this.ItemOptions.value;
    form.Price = this.Price.value;
    form.PriceType = this.PriceType.value;

    form.GTIN=this.GTIN.value;
    form.Name = this.Name.value;
    form.AlternativeName = this.AlternativeName.value;
    form.Description = this.Description.value;
    // form.ItemOptions = this.ItemOptions.value;
    form.Price = this.Price.value;
    form.PriceType = this.PriceType.value;
    
    if(form.PriceType=="Fixed")
    {
      form.PriceType ="0";
    }
    else if(form.PriceType=="Variable")
    {
      form.PriceType="1" ;
    }
    else if(form.PriceType=="Per Unit")
    {
      form.PriceType="2" ;
    }
    form.TaxFeeId=this.Taxes.value;
    form.ProductCode=this.ProductCode.value;
    form.Sku=this.Sku.value;
    form.UpdateduserId=this.UpdateduserId.value;
    form.UpdatedDateTime=this.UpdatedDateTime.value;
    form.id=this.rid;
     form.DateTime=this.rdatetime;
    // form.imageSource=this.imageSource.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    var imageurl=this.itemimage;
    if(imageurl==undefined || imageurl=="")
    {
    
           form.content=this.content;
           form.ContentType=this.contenttype;
    }
  
    const frmData = new FormData();
    frmData.append("fileUpload", this.myFiles[0]);
    this.service.UpdateItem(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        if( this.imagecheck=="Image is Updated")
        {
          this.service.InsertItem(result.Id,merchantdata.PosSubscriptionId,frmData).subscribe(result => {

          })
        }
    
        var length = +localStorage.getItem('orderlength')
        if(length>0)
        {
        swal("Updated", "Items Updated Successfully", "success"); 
        this.router.navigate(["/pos/item/manage"]);
        }
        else
        {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
  }

// Image Upload

getFileDetails (e,value) {
  this.isReadytoUpdateitem = true;
  //  this.validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"]; 
   this.validFileExtensions = [".jpeg", ".jpg", ".png", ".bmp",".doc",".docx",".pdf"];
  for (var i = 0; i < e.target.files.length; i++) { 
    this.myFiles.push(e.target.files[i],value);
   
   var sFileName = e.target.files[i].name;
   this.fileSize = e.target.files[i].size;
   if (sFileName.length > 0) {
    this.imagecheck="Image is Updated"
       var blnValid = false;
       for (var j = 0; j < this.validFileExtensions.length; j++) {
           var sCurExtension = this.validFileExtensions[j];
           if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
               blnValid = true;
               this.isfileValid =  true;
               break;
           }
       }
       
       if (!blnValid) {
         this.isfileValid = false;
          // alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + this.validFileExtensions.join(", "));
           return false;
       }
   }
  }
   if(this.myFiles.length!= null)
   {
    this.isUploadFile = true;
   }
   else{
    this.isUploadFile = false;
   }
   if(this.fileSize< this.maxFileSize)
   {
     this.isFileHavingProperSize = false;
   }
   else{
     this.isFileHavingProperSize = true;
   }

}




  firstNameError() {
    return this.Name.hasError("required") ? " Name is required"
      : this.Name.hasError("pattern") ? "Name should be allow only alphabets and numbers" : "";
  }

  AlternativeNameError() {
    return this.AlternativeName.hasError("pattern") ? " Alternative Name should be allow only alphabets and numbers" : "";
  }

  itemoptionerror() {
    return this.ItemOptions.hasError("required") ? " item options  is required"
      : this.ItemOptions.hasError("pattern") ? " item options should be allow only numbers" : "";
  }
 priceerror() {
    return this.Price.hasError("required") ? " Price  is required"
    : this.Price.hasError("min") ? "Invalid Price"
      : this.Price.hasError("pattern") ? " Price should be numbers only" : "";
  }
 pricetypeerror() {
    return this.PriceType.hasError("required") ? " Price Type  is required"
      : this.PriceType.hasError("pattern") ? "Price Type should be allow only numbers" : "";
  }
 taxeerror() {
    return this.Taxes.hasError("required") ? " Taxes  is required"
      : this.Taxes.hasError("pattern") ? " Taxes should be allow only numbers" : "";
  }
  productCodeerror()
  {
    return this.ProductCode.hasError("required") ? " Product Code  is required" : "";
   
  }
  DiscountValueerror() {
    return this.DiscountValue.hasError("required") ? " DiscountValue  is required"
    : this.DiscountValue.hasError("min") ? "Invalid DiscountValue"
      : this.DiscountValue.hasError("pattern") ? " DiscountValue should be numbers only" : "";
  }
  DiscountTypeeerror() {
    return this.DiscountType.hasError("required") ? " Discount Type  is required"
      : this.DiscountType.hasError("pattern") ? "Discount Type should be allow only numbers" : "";
  }

  DescriptionError()
  {
    return this.Description.hasError("required") ? " Description  is required" : "";
  }
  BarCodeError()
  {
    return this.BarCode.hasError("required") ? " BarCode  is required" : "";
  }
  GTINError()
  {
    return this.GTIN.hasError("required") ? " GTIN  is required" : "";
  }
  typeerrors()
  {
    return this.PriceType.hasError("required") ? " PriceType  is required" : "";
  }
   
  onKey()
  {
    this.isReadytoUpdateitem = true;
  }



  checkproduct()
  {
    let form = { 
      PosSubscriptionId: "",
     ProductCode: "",
    };
  
     
       form.ProductCode = this.ProductCode.value;
       form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
  

 
     this.service.GetDuplicateProductCode(form).subscribe(result => {   
       // console.log("result.Id---" + result);
       if(result !=null)
       {
          this.duplicateproductcode=true;            
       }
       else{
          this.duplicateproductcode=false;  
       }
     });
  
  }
  DisCountcal()
  {
    if(this.DiscountValue.value ==this.EditdiscountValue  && this.DiscountType.value ==this.EditdiscountType)
    {
      this.Flag=0;
    }
    else{
      this.Flag=1;
    }

  }
}
